/**
 * Envoi partiel — comportement de la case au panier.
 *
 * Coché   → ajoute le produit "Frais d'envoi partiel" (4,90 €) + attribut envoi_partiel=oui
 * Décoché → retire le produit frais + attribut envoi_partiel=non
 * Puis déclenche `cart:refresh` (FoxTheme re-render le panier + le drawer).
 *
 * Garde-fou : si le frais est au panier alors que l'option n'est plus éligible
 * (bloc [data-partial-shipment] absent après re-render), on le retire automatiquement.
 */
(function () {
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const FEE_VARIANT_ID = 48917855207563; // "Frais d'envoi partiel"
  let busy = false;

  // CSS : masque les badges délai de l'app au panier (non stock-aware, défaut faux)
  // et stylise notre badge stock-aware .ps-item-delay. Injecté une fois.
  (function injectCss() {
    if (document.getElementById('ps-css')) return;
    const s = document.createElement('style');
    s.id = 'ps-css';
    s.textContent =
      '.cart-item [class*="ltd-"],.ltd-cart-wrapper,[class*="ltd-badge--cart"],[class*="ltd-badge--compact"]{display:none !important}' +
      // Masque la ligne du produit "Frais d'envoi partiel" (le frais est indiqué dans le bloc option + le total)
      '[data-variant-id="' + FEE_VARIANT_ID + '"],.ps-fee-line{display:none !important}' +
      '.ps-item-delay{display:flex;gap:5px;align-items:center;margin:2px 0 0;font-size:.85em;line-height:1.3;color:#8a5a2b}' +
      '.ps-item-delay--ok{color:#2e7d32}' +
      '.ps-item-delay svg{width:14px;height:14px;flex:0 0 auto}';
    (document.head || document.documentElement).appendChild(s);
  })();

  function feeVariantId() {
    const el = document.querySelector('[data-partial-shipment]');
    return el ? el.getAttribute('data-fee-variant-id') : FEE_VARIANT_ID;
  }

  async function postJSON(url, body) {
    const res = await fetch(ROOT.replace(/\/$/, '') + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    return res.json();
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  async function getCart() {
    return fetch(ROOT.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  async function setPartial(on) {
    if (busy) return;
    busy = true;
    try {
      // État courant du panier : on retire par CLÉ de ligne (fiable), et on est idempotent.
      const cart = await getCart();
      const feeLine = (cart.items || []).find((it) => it.variant_id === FEE_VARIANT_ID || it.id === FEE_VARIANT_ID);
      if (on && !feeLine) {
        await postJSON('/cart/add.js', { items: [{ id: FEE_VARIANT_ID, quantity: 1 }] });
      } else if (!on && feeLine) {
        await postJSON('/cart/change.js', { id: feeLine.key, quantity: 0 });
      }
      await postJSON('/cart/update.js', { attributes: { envoi_partiel: on ? 'oui' : 'non' } });
      refreshCart();
    } catch (e) {
      console.error('[envoi-partiel]', e);
    } finally {
      busy = false;
    }
  }

  // Délégation : la case est re-rendue à chaque refresh du panier.
  document.addEventListener('change', function (e) {
    const cb = e.target.closest && e.target.closest('[data-partial-checkbox]');
    if (!cb) return;
    setPartial(cb.checked);
  });

  // Garde-fou : frais présent mais option non éligible → le retirer.
  async function guardStaleFee() {
    if (busy) return;
    const block = document.querySelector('[data-partial-shipment]');
    if (block) return; // éligible → rien à faire
    // Pas de bloc option : si le frais est au panier, on le retire.
    try {
      const cart = await fetch(ROOT.replace(/\/$/, '') + '/cart.js').then((r) => r.json());
      const feeLine = (cart.items || []).find((it) => it.variant_id === FEE_VARIANT_ID || it.id === FEE_VARIANT_ID);
      if (feeLine) {
        busy = true;
        await postJSON('/cart/change.js', { id: feeLine.key, quantity: 0 });
        await postJSON('/cart/update.js', { attributes: { envoi_partiel: 'non' } });
        busy = false;
        refreshCart();
      }
    } catch (e) {
      /* silencieux */
    }
  }

  document.addEventListener('cart:updated', guardStaleFee);
  document.addEventListener('DOMContentLoaded', guardStaleFee);
})();
